import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { Col } from 'antd';
import { checkPermissionsHOC } from '../../../../App/CheckPermissions';

const mapStateToProps = (state) => {
    const { marketing, ref_lead_source, created_by } = state.Leads.Lead_profile.Lead_marketing;
    return {
        ref_lead_source, marketing, created_by, fields_permissions: state.App.Permissions.fields_permissions,
    };
};

export default connect(mapStateToProps, null)(checkPermissionsHOC(class Marketing extends Component {
    componentWillUnmount() {
        this.props.dispatch({ type: 'RESET_PERMISSIONS' });
    }

    render() {
        return (
            <Col span={24}>
                {this.props.fields_permissions['field://Lead/marketing']
         && this.props.marketing && this.props.ref_lead_source && this.props.created_by
          && (
              <Fragment>
                  <h3 className="header">Marketing</h3>
                  <p>
                      <span>Division</span>
                      <span className="value">{this.props.ref_lead_source.abbr}</span>
                  </p>
                  <p>
                      <span>Created by</span>
                      <span className="value">
                          {this.props.created_by.person && this.props.created_by.person.first_name}
                  &nbsp;
                          {this.props.created_by.person && this.props.created_by.person.last_name}
                      </span>
                  </p>
                  <p>
                      <span>Campaign</span>
                      <span className="value">{this.props.marketing.campaign || '-'}</span>
                  </p>
                  <p>
                      <span>IP Address</span>
                      <span className="value">{this.props.marketing.ip_address || '-'}</span>
                  </p>
                  <p>
                      <span>Source</span>
                      <span className="value">{this.props.marketing.source || '-'}</span>
                  </p>
                  <p>
                      <span>PPC Keyword</span>
                      <span className="value">{this.props.marketing.ppc_keyword || '-'}</span>
                  </p>
                  <p>
                      <span>Affiliate Id</span>
                      <span className="value">{this.props.marketing.ref_lead_affiliate && (this.props.marketing.ref_lead_affiliate.name || '-')}</span>
                  </p>
                  <p>
                      <span>User Agent</span>
                      <span className="value">{this.props.marketing.user_agent || '-'}</span>
                  </p>
              </Fragment>
          )}
            </Col>
        );
    }
}, ['field://Lead/marketing'], 'fields'));
// TagP01nts.



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_profile/components/Lead_profile_table/Marketing.js